// Mirrors portal/backend/lib/compliance-tier.mjs. Display only: the API answers 403 tier_not_included on its own.
// Compliance reports are included from the professional tier upward; a missing tier is starter.
export const complianceAllowedForTier = (t) => (t ?? 'starter') === 'professional' || (t ?? 'starter') === 'enterprise';
